import { createFileRoute } from '@tanstack/react-router'
import React from "react";
import PlayersView from "../../../players/PlayersView.tsx";

export const Route = createFileRoute('/_app/players/$player_uid')({
  component: RouteComponent,
})

function RouteComponent() {
  return <PlayersView />
}
